import React, {useEffect, useState} from 'react';
import UploadCMP from "@/components/upload";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiLmsSaveFileUploaded} from "@/api/lms";

function UploadSection({lessonDetail, setCanContinue}) {
    const [haveFile, setHaveFile] = useState(null)
    const {mutate: saveAudio, isPending} = useApiLmsSaveFileUploaded()

    useEffect(() => {
        setCanContinue(haveFile)
    }, [haveFile])


    function handleSubmitFile(file) {

        setHaveFile(file)
        saveAudio({
            id: lessonDetail?.data?.data?.id,
            file_id: file?.file?.response?.data?.id,

        }, {
            onSuccess: res => {
                ApiHandleSuccessMessage(res)
            },
            onError: err => {
                ApiHandleErrorMessage(err)
            }
        })
    }

    return (
        <>
            <UploadCMP dragMode={true} model={''}
                       afterUploadFn={(file) => handleSubmitFile(file)}/>

        </>
    );
}

export default UploadSection;